// Google Analytics (GA4) via gtag.js. Enabled only when VITE_GA_MEASUREMENT_ID
// is set (production build); otherwise every call is a no-op and nothing loads.

const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

let enabled = false;

function gtag(...args: unknown[]): void {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(args);
}

export function analyticsEnabled(): boolean {
  return enabled;
}

export function initAnalytics(): void {
  if (!GA_MEASUREMENT_ID) return;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  gtag('js', new Date());
  // page_view is emitted manually on route changes, so disable the automatic one.
  gtag('config', GA_MEASUREMENT_ID, { send_page_view: false });
  enabled = true;
}

/** Log a GA4 page_view. No-op until analytics is initialized. */
export function trackPageView(path: string, title?: string): void {
  if (!enabled) return;
  gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: title ?? document.title,
  });
}

/** Log a named GA4 event (begin_checkout, purchase, donate_click, merch_click). */
export function trackEvent(name: string, params?: Record<string, unknown>): void {
  if (!enabled) return;
  gtag('event', name, params ?? {});
}
